import { db } from "./db";
import { API } from "./supabase";

/* Claim secret: a per-token UUID that never leaves the device; only its sha256 hex goes to the server. Stored in IDB "meta". */
const KEY = (token) => `claim-secret:${token}`;

const sha256 = async (s) => {
  const buf = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(s));
  return [...new Uint8Array(buf)].map((b) => b.toString(16).padStart(2, "0")).join("");
};

export const claimSecret = async (token) => {
  let rec = await db.get("meta", KEY(token));
  if (!rec) {
    const secret = crypto.randomUUID();
    rec = { secret, hash: await sha256(secret), claimed_at: null };
    await db.put("meta", rec, KEY(token));
  }
  return rec;
};
export const rememberClaim = async (token, claimedAt) => { const rec = await claimSecret(token); await db.put("meta", { ...rec, claimed_at: claimedAt }, KEY(token)); };

export const claimJob = async (token, hash, name, phone) => {
  const r = await fetch(`${API}/public/dispatch/${token}/claim`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ name, phone: phone || null, secret_hash: hash }) });
  const body = await r.json().catch(() => ({}));
  return { ok: r.ok, status: r.status, body };
};

/** Derive the claim UI state. `legacy` = pre-015 server (no claim fields) → behave as before. */
export const claimState = (job, rec) => {
  if (!job || !("claimed_at" in job)) return "legacy";
  if (job.status === "completed") return "completed";
  if (!job.claimed_at) return job.claim_released_at && rec?.claimed_at ? "released" : "unclaimed";
  const mine = job.claim_mine === true || (rec?.claimed_at && Math.abs(new Date(job.claimed_at) - new Date(rec.claimed_at)) < 2000);
  return mine ? "mine" : "taken";
};

export const fmtClaimTime = (iso) => new Date(iso).toLocaleTimeString(undefined, { hour: "2-digit", minute: "2-digit" });
